// SearchSelect / SearchMultiSelect ortak görünümü (tek kaynak — iki seçici birebir aynı görünür).
import type { CSSProperties } from "react";

export const triggerStyle: CSSProperties = {
  width: "100%",
  display: "flex",
  alignItems: "center",
  gap: 8,
  textAlign: "left",
  background: "var(--color-surface)",
  border: "1px solid var(--color-border)",
  borderRadius: 8,
  padding: "6px 10px",
  color: "var(--color-text)",
  cursor: "pointer",
  minWidth: 0,
};
export const rowTextStyle: CSSProperties = {
  display: "flex",
  alignItems: "baseline",
  gap: 8,
  minWidth: 0,
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  flex: 1,
};
export const codeStyle: CSSProperties = {
  fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
  fontSize: "0.78em",
  color: "var(--color-text-3)",
  overflow: "hidden",
  textOverflow: "ellipsis",
};
export const hintStyle: CSSProperties = {
  color: "var(--color-text-3)",
  marginLeft: "auto",
  flexShrink: 0,
};
export const popStyle: CSSProperties = {
  position: "absolute",
  left: 0,
  right: 0,
  top: "100%",
  marginTop: 4,
  zIndex: 60,
  background: "var(--color-surface)",
  border: "1px solid var(--color-border)",
  borderRadius: 10,
  boxShadow: "0 10px 30px rgba(0,0,0,0.14)",
  padding: 6,
  minWidth: 260,
};
export const searchStyle: CSSProperties = {
  width: "100%",
  boxSizing: "border-box",
  border: "1px solid var(--color-border)",
  borderRadius: 8,
  padding: "8px 10px",
  fontSize: "0.875rem",
  marginBottom: 4,
  background: "var(--color-bg)",
  color: "var(--color-text)",
};
export const listStyle: CSSProperties = {
  listStyle: "none",
  margin: 0,
  padding: 0,
  maxHeight: 300,
  overflowY: "auto",
};
export const itemStyle: CSSProperties = {
  display: "flex",
  alignItems: "center",
  minHeight: 36,
  padding: "6px 10px",
  borderRadius: 6,
  cursor: "pointer",
  fontSize: "0.85rem",
};
/** bölümlü listede seçilemez bölüm başlığı (SearchSelect `group`) */
export const groupHeaderStyle: CSSProperties = {
  padding: "8px 10px 4px",
  fontSize: "0.75rem",
  fontWeight: 700,
  color: "var(--color-text-3)",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
  cursor: "default",
};
